import { IApplicationData } from "models/application-data";
import { PaginationResponse } from "models/pagination-response";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import { IBannersListResponse } from "models/response/banners-list-response";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";

export type ServicesState = {
    linkServicesResponse: ILinkServicesListResponse[];
    linkServicesRequest: ILinkServicesListRequest;
    loading: boolean;
};

export enum ACTION_TYPES {
    setLinkServicesResponse = 'setLinkServicesResponse',
    setLinkServicesRequest = 'setLinkServicesRequest',
    setLoading = 'setLoading'
}

export const ServicesReducer = (state: ServicesState, action: any): ServicesState => {
    const { type, payload } = action;
    switch (type) {

        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        case ACTION_TYPES.setLinkServicesResponse:
            return {
                ...state,
                linkServicesResponse: payload,
            };

        case ACTION_TYPES.setLinkServicesRequest:
            return {
                ...state,
                linkServicesRequest: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}